import * as cookie from 'cookie';

/**
 * 쿠키 문자열을 객체로 파싱합니다.
 * @description
 * - undefined 값은 제거합니다.
 * @example
 * // parseCookie('foo=bar')
 */
export const parseCookies = (cookieStr: string): Record<string, string> => {
  const parsed = cookie.parse(cookieStr);

  return Object.fromEntries(
    Object.entries(parsed).filter(([, value]) => value !== undefined),
  ) as Record<string, string>;
};
